__turbopack_context__.v({
  "text": "rich-text-module__8-0qha__text",
});
